module.exports = __webpack_public_path__ + "img/icon_end.3315e073.svg";